import { memo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '~/components/atomic';
import { FullScreenLoading } from '~/components/common';
import Tooltip from '~/components/common/Tooltip/Tooltip';
import { useCopyCharacterMutation } from '~/features/chatRoom';
import { useModal } from '~/hooks';
import { ModalParams } from '~/types';
import { PAGE_ROUTE } from '~/constants';
import { useCommonChatStore, useUserStore } from '~/store';
import * as S from './SubMenu.styled';

interface SubMenuProps {
  isNotificationOn: boolean;
  handleNotifyClick: () => void;
  isSafeChatOn: boolean;
  handleSafeModeClick: () => void;
  handleReportClick: () => void;
}

const SubMenu = memo(
  ({
    isNotificationOn,
    handleNotifyClick,
    isSafeChatOn,
    handleSafeModeClick,
    handleReportClick,
  }: SubMenuProps) => {
    const { openModal } = useModal();
    const navigate = useNavigate();
    const type = useCommonChatStore((state) => state.roomType);

    const avatarInfo = useCommonChatStore((state) => state.avatarInfo);
    const setShowLeaveRoomOpen = useCommonChatStore(
      (state) => state.setShowLeaveRoomOpen,
    );
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);
    const { mutate, isPending } = useCopyCharacterMutation();

    const modalData: ModalParams = {
      // 현재 20240527 기준 1대1 채팅에서만 copy 기능
      title: 'Saved',
      content:
        'You can find it under My avatar in the generate tab. persona are excluded.',
      type: 'single',
      buttonName: 'Okay',
    };

    const handleCopyCharacter = () => {
      if (avatarInfo && avatarInfo.length > 0) {
        mutate(
          {
            character_id: avatarInfo[0].id,
          },
          {
            onSuccess: ({ status }) => {
              openModal(modalData);
            },
          },
        );
      }
    };

    return (
      <>
        {isPending && <FullScreenLoading />}

        <S.Container>
          <S.Wrapper>
            <S.SubMenu>
              <span>Notification</span>
              <S.ToggleButtonBox>
                <S.Input
                  type='checkbox'
                  id='NotiToggleButton'
                  hidden
                  checked={isNotificationOn}
                  onChange={handleNotifyClick}
                />
                <S.ToggleButton
                  htmlFor='NotiToggleButton'
                  className='toggleButton'
                >
                  <S.Toggle className='toggle' />
                </S.ToggleButton>
              </S.ToggleButtonBox>
            </S.SubMenu>
            <S.SubMenu>
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                Safe chat
                <Icon
                  iconName='Alert'
                  size={16}
                  style={{
                    paddingLeft: '8px',
                  }}
                  onClick={() => setIsTooltipOpen(true)}
                />
              </span>
              <S.ToggleButtonBox>
                <S.Input
                  type='checkbox'
                  id='safeChat'
                  hidden
                  checked={isSafeChatOn}
                  onChange={handleSafeModeClick}
                />
                <S.ToggleButton htmlFor='safeChat' className='toggleButton'>
                  <S.Toggle className='toggle' />
                </S.ToggleButton>
              </S.ToggleButtonBox>
              {isTooltipOpen && (
                <Tooltip
                  top={44}
                  left={14}
                  onClose={() => setIsTooltipOpen(false)}
                >
                  Filters out potentially harmful AI-generated chats, including
                  sexually explicit or violent content
                </Tooltip>
              )}
            </S.SubMenu>
            <S.SubMenu
              onClick={() =>
                navigate(
                  `${PAGE_ROUTE.CHARACTER_DETAILS}/${
                    avatarInfo && avatarInfo[0].id
                  }`,
                  {
                    state: { fromChatRoom: true, type },
                  },
                )
              }
            >
              <span>Character profile</span>
            </S.SubMenu>
            <S.SubMenu onClick={handleCopyCharacter}>
              <span>Copy avatar</span>
            </S.SubMenu>
            <S.SubMenu onClick={handleReportClick}>
              <span>Report</span>
            </S.SubMenu>
            <S.SubMenu
              className='red'
              onClick={() => setShowLeaveRoomOpen(true)}
            >
              <span>Leave</span>
            </S.SubMenu>
          </S.Wrapper>
        </S.Container>
      </>
    );
  },
);

export default SubMenu;
